import { API_URL, getTime } from './_setting.js';
import { titles } from './_title.js';

export let rankingModal = {
	init: function(){
		rankingModal.add();
		rankingModal.nav();
	},
	nav: function(){
		let $btn = document.querySelector(".c-start_btns button[data-ranking]");
		$btn.removeEventListener("click", rankingModal.open, false);
		$btn.addEventListener("click", rankingModal.open, false);
	},
	add: async function(ms){
		try {
			const res = await fetch(API_URL);
			if (!res.ok) return;
			
			const ranking = await res.json();
			ranking.sort((a, b) => a.time - b.time);
			const top10 = ranking.slice(0, 10);
			rankingModal.makeHTML(top10);
		} catch (e) {
			console.error("通信エラー:", e);
		}
	},
	makeHTML: function( ranking ){
		let HTML = "";
		ranking.forEach((r, index) => {
			let time = getTime(r.time);
			let name = `<dt>${r.name}</dt>`;
			HTML += `<li class="rank${index}">
						<div class="inr">
							<div class="rank">
								<p class="num">${index + 1}</p>
								<span class="icon_rank"></span>
							</div>
							<dl>
								${name}
								<dd>
									<p class="time">🕐 ${time}</p>
									<p class="title">👑 ${ rankingModal.getTitle(r.time) }</p>
								</dd>
							</dl>
						</div>
					</li>`;
		});
		document.querySelector("#ranking_only ul").innerHTML = HTML;
	},
	open: function(){
		let $html = document.documentElement;
		if( !$html.classList.contains("show-ranking") ){
			$html.classList.add("show-ranking");
			let $closeBtns = document.querySelectorAll("#b-ranking button[data-modal-close]");
			$closeBtns.forEach( ($close) => {
				$close.removeEventListener("click", rankingModal.close, false);
				$close.addEventListener("click", rankingModal.close, false);
			});
		}
	},
	close: function(){
		let $html = document.documentElement;
		if( $html.classList.contains("show-ranking") ){
			$html.classList.remove("show-ranking")
		}
	},
	getTitle: function(ms){
		const sec = Math.floor(ms / 1000);
		const title = titles.find(t => sec >= t.start && sec < t.end);
		return title ? title.name : null;
	}
}